import { put, takeLatest } from 'redux-saga/effects';
import SagasHelper from "../../helpers/Redux/SagasHelper";
import { CategoriesActions } from "./actionCreators";
import { CATEGORY_ACTION } from "./actionTypes";
import { CategoriesApi } from "./api";
/**
 * Create category
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{cities, type}>|CallEffect|PutEffect<{type}>>}
 */

function* create(action) {
  yield SagasHelper.action(action, CategoriesApi.create);
}
/**
 * View category
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{cities, type}>|CallEffect|PutEffect<{type}>>}
 */


function* view(action) {
  yield SagasHelper.action(action, CategoriesApi.view);
}
/**
 * List categories
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{cities, type}>|CallEffect|PutEffect<{type}>>}
 */


function* list(action) {
  yield SagasHelper.action(action, CategoriesApi.list);
}
/**
 * Update category
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{cities, type}>|CallEffect|PutEffect<{type}>>}
 */


function* update(action) {
  yield SagasHelper.action(action, CategoriesApi.update);
}
/**
 * Delete category
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{cities, type}>|CallEffect|PutEffect<{type}>>}
 */


function* deleteModel(action) {
  yield SagasHelper.action(action, CategoriesApi.delete);
}
/**
 * Get hierarchical categories
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|CallEffect|PutEffect<{type}>|PutEffect<{categories, type}>>}
 */


function* fetchHierarchicalCategories(action) {
  yield SagasHelper.action(action, CategoriesApi.hierarchical, null, null, function* (response) {
    const {
      result
    } = response;
    yield put(CategoriesActions.setHierarchical(Object.values(result)));
  });
}
/**
 * Get home page categories
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{cities, type}>|CallEffect|PutEffect<{type}>>}
 */


function* popularCategories(action) {
  yield SagasHelper.action(action, CategoriesApi.popularCategories);
}
/**
 * Category filters
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{cities, type}>|CallEffect|PutEffect<{type}>>}
 */


function* filters(action) {
  yield SagasHelper.action(action, CategoriesApi.filters);
}

export default [takeLatest(CATEGORY_ACTION.CREATE, create), takeLatest(CATEGORY_ACTION.VIEW, view), takeLatest(CATEGORY_ACTION.LIST, list), takeLatest(CATEGORY_ACTION.UPDATE, update), takeLatest(CATEGORY_ACTION.DELETE, deleteModel), takeLatest(CATEGORY_ACTION.FETCH_HIERARCHICAL, fetchHierarchicalCategories), takeLatest(CATEGORY_ACTION.HOME_CATEGORIES, popularCategories), takeLatest(CATEGORY_ACTION.FILTERS, filters)];